// (c) chaehongee. Confidential and proprietary.

import type { ReactElement, CSSProperties } from 'react'
import { memo } from 'react'
import styles from '../../Canvas.module.css'

interface ImageItemProps {
    src: string
    onLoad?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void
    onError?: () => void
    rect?: { x: number; y: number; w: number; h: number } | null
    frameClipRect?: { x: number; y: number; w: number; h: number }
    selected?: boolean
}

export const ImageItem = memo(function ImageItem(props: ImageItemProps): ReactElement {
    const { src, onLoad, onError, rect, frameClipRect, selected } = props
    // Render clipped inside a frame when frameClipRect is provided
    if (frameClipRect && rect) {
        const frameStyle: CSSProperties = {
            left: frameClipRect.x,
            top: frameClipRect.y,
            width: frameClipRect.w,
            height: frameClipRect.h,
        }
        const innerStyle: CSSProperties = {
            position: 'absolute',
            left: rect.x - frameClipRect.x,
            top: rect.y - frameClipRect.y,
            width: rect.w,
            height: rect.h,
        }
        return (
            <div
                className={styles.frameClip + (!selected ? ' ' + styles.worldItemOutline : '')}
                style={frameStyle}
            >
                <img
                    src={src}
                    alt="selected"
                    loading="lazy"
                    referrerPolicy="no-referrer"
                    draggable={false}
                    style={{ ...innerStyle, objectFit: 'fill', pointerEvents: 'none' }}
                    onLoad={onLoad}
                    onError={onError}
                />
            </div>
        )
    }
    return (
        <img
            src={src}
            alt="selected"
            loading="lazy"
            referrerPolicy="no-referrer"
            draggable={false}
            style={
                rect
                    ? {
                        position: 'absolute',
                        left: rect.x,
                        top: rect.y,
                        width: rect.w,
                        height: rect.h,
                        // The rect already preserves the aspect ratio; fill avoids extra letterboxing
                        objectFit: 'fill',
                        pointerEvents: 'none',
                    }
                    : { width: '100%', height: '100%', objectFit: 'contain' }
            }
            onLoad={onLoad}
            onError={onError}
        />
    )
})





